export default __webpack_public_path__ + "static/media/BaseballBat_8.cc130138.png";